import axios from "axios";
// Base URL

// export const API_BASE_URL = "https://League-score.ftisindia.com";
export const API_BASE_URL="https://score-admin.ftisindia.com" 



const encodeReqData = (data) => btoa(encodeURIComponent(JSON.stringify(data))); 
const decodeReqData = (data) => JSON.parse(decodeURIComponent(atob(data)));     


const buildHeaders = () => ({
  "Content-Type": "application/json",

});

const getEventRowId = () => localStorage.getItem("event_row_id") || "default_event_id";


// const getEventRowId = () => localStorage.getItem("event_row_id");

// API Post Function
const apiHandler = async (data, url = "common/noauth") => {
  try {
    const payload = encodeReqData(data);
    const response = await axios.post(
      `${API_BASE_URL}/${url}`,
      { payload },
      { headers: buildHeaders(), responseType: "text" }
    );
    console.log("response=====>",response);

      const decodedResp =decodeReqData(response.data)
    // console.log("Decoded Data",decodedResp.data);
    // return decodeReqData(response.data);
    return decodedResp 
  } catch (error) {
    const decodedError = decodeReqData(error.response.data || "{}");
    console.error("API Error:", decodedError);
    throw decodedError;
  }
};
export { apiHandler, getEventRowId };




























































